import React from 'react';
import { Lock, CreditCard, Download, CheckCircle, Zap, Clock, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="bg-[#0d1f35] py-16 px-4 sm:px-6 lg:px-8" data-id="element-146">
      <div className="max-w-5xl mx-auto" data-id="element-147">
        {/* Urgency Header */}
        <div className="text-center mb-8" data-id="element-148">
          <div className="inline-flex items-center gap-2 bg-red-500 text-white text-sm font-bold px-5 py-2 rounded-full mb-4 animate-pulse" data-id="element-149">
            <Clock className="w-4 h-4" data-id="element-150" /> OFERTA POR TIEMPO LIMITADO
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-3" data-id="element-151">
            Accedé ahora a{' '}
            <span className="text-[#d4a853]" data-id="element-152">POLÍTICA Y CIUDADANÍA 360</span>
          </h2>
          <p className="text-blue-200" data-id="element-153">
            Resolvé el año completo con un sistema probado, claro y listo para
            usar.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#d4a853]" data-id="element-154">
          {/* Top Banner */}
          <div className="bg-[#d4a853] p-3 text-center" data-id="element-155">
            <p className="text-[#1e3a5a] font-black text-base flex items-center justify-center gap-2" data-id="element-156">
              <Zap className="w-4 h-4" data-id="element-157" /> 🎁 Incluye todos los bonos GRATIS por
              tiempo limitado
            </p>
          </div>

          <div className="p-6 sm:p-8 md:p-10" data-id="element-158">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-10" data-id="element-159">
              {/* Product Image */}
              <div className="w-full lg:w-1/2" data-id="element-160">
                <div className="relative" data-id="element-161">
                  <div className="absolute -inset-2 bg-gradient-to-r from-[#d4a853] to-[#1e3a5a] rounded-2xl blur opacity-30" data-id="element-162"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/3MdZ6pAmuJnbfB4t6UavwB/MOCKUP_PRINCIPAL_POLITICA_Y_CIUDADANIA.png" alt="Pack Completo Política y Ciudadanía 360" className="relative w-full rounded-xl shadow-lg" data-id="element-163" />
                </div>
                <div className="mt-4 space-y-1.5" data-id="element-164">
                  {['Clases anuales completas', 'Secuencia pedagógica ordenada', 'Actividades de debate listas', 'Material 100% editable', '+ 3 Bonos exclusivos GRATIS'].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-165">
                      <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-166" />
                      <span data-id="element-167">{item}</span>
                    </div>)}
                </div>
              </div>

              {/* Pricing */}
              <div className="w-full lg:w-1/2 text-center" data-id="element-168">
                <p className="text-gray-400 text-lg line-through mb-1" data-id="element-169">
                  Precio Normal: $49.990
                </p>
                <p className="text-6xl md:text-7xl font-extrabold text-[#1e3a5a] mb-1 leading-none" data-id="element-170">
                  $19.990
                </p>
                <span className="inline-block bg-green-100 text-green-700 px-4 py-1.5 rounded-full text-sm font-bold border border-green-200 mb-4" data-id="element-171">
                  ¡AHORRÁS $30.000 HOY!
                </span>
                <p className="text-sm text-gray-500 mb-6" data-id="element-172">
                  Pago único · Acceso inmediato · Sin suscripciones
                </p>

                <a href="https://checkout.rincondigital.shop/cart/53401040617747:1" target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-173">
                  <button className="w-full bg-[#d4a853] hover:bg-[#c49843] text-[#1e3a5a] text-xl font-black py-5 px-8 rounded-xl shadow-xl border-b-4 border-[#b48833] active:border-b-0 active:translate-y-1 transform transition-all duration-200 hover:scale-105 mb-3" data-id="element-174">
                    ⚡ DESCARGAR EL PACK AHORA
                  </button>
                </a>

                <p className="text-sm text-gray-500 mb-4" data-id="element-175">
                  👆 Hacé clic y empezá a organizar tu año
                </p>

                <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-gray-400" data-id="element-176">
                  <div className="flex items-center gap-1" data-id="element-177">
                    <Lock className="w-3.5 h-3.5" data-id="element-178" /> Pago Seguro
                  </div>
                  <div className="flex items-center gap-1" data-id="element-179">
                    <CreditCard className="w-3.5 h-3.5" data-id="element-180" /> Todos los medios
                  </div>
                  <div className="flex items-center gap-1" data-id="element-181">
                    <Download className="w-3.5 h-3.5" data-id="element-182" /> Descarga inmediata
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Guarantee Stamp - sealed to the bottom */}
          <div className="bg-green-50 border-t-2 border-dashed border-green-200 px-6 py-4 flex items-center justify-center gap-3" data-id="element-183">
            <ShieldCheck className="w-8 h-8 text-green-600 flex-shrink-0" data-id="element-184" />
            <div className="text-center sm:text-left" data-id="element-185">
              <span className="font-black text-green-800 text-sm uppercase tracking-wide" data-id="element-186">
                Garantía de Satisfacción Total — 7 días
              </span>
              <p className="text-green-700 text-xs mt-0.5" data-id="element-187">
                Si no cumple tus expectativas, te devolvemos el 100% de tu
                dinero. Sin preguntas, sin complicaciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}